import { CloudFog, Eye } from "lucide-react";
import { dictionaries } from "../lib/i18n";
import type { Clarity, UiLang } from "../lib/types";

/**
 * Om det er sikt fra utsiktspunktet, som ett merke.
 *
 * Utsiktsindeksen ved siden av svarer på noe bredere — hvor god dagen er på
 * stedet, veid av nedbør, dagslys og hvor mye stedet står og faller på sikt.
 * Dette merket svarer på ett spørsmål: står det tåke der oppe?
 *
 * De to er ikke det samme, og det er derfor de står ved siden av hverandre.
 * En tørr, lys oktoberdag kan gi en pen utsiktsindeks på Dalsnibba og likevel
 * være førti minutter opp til en parkeringsplass inne i en sky. Tallet som
 * fanger det er `fog_area_fraction` fra MET, og det er det eneste feltet
 * appen ikke hentet.
 *
 * Vises bare der stedet er et utsiktspunkt eller ligger over fem hundre meter
 * — serveren avgjør det, se api/src/services/clarity.ts. Et tåkemerke på
 * Bryggens Museum ville vært støy.
 */

interface Props {
  clarity: Clarity;
  lang: UiLang;
  /** Kompakt utgave for taggraden i tidslinja: bare status, ingen tall. */
  compact?: boolean;
}

export function ClarityBadge({ clarity, lang, compact }: Props) {
  const t = dictionaries[lang];
  const Icon = clarity.status === "klar" ? Eye : CloudFog;

  return (
    <span
      className={`clarity clarity--${clarity.status}`}
      title={t.clarityDetail(clarity.fogPercent, clarity.cloudPercent)}
    >
      <Icon size={12} />
      {t.clarityStatus[clarity.status]}
      {!compact && (
        <small className="clarity-detail">
          {t.clarityDetail(clarity.fogPercent, clarity.cloudPercent)}
        </small>
      )}
    </span>
  );
}
